/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

// params.partnerId — партнёр брони: бэк вернёт справочник этого партнёра + «общие» записи.
export function getCounteragents(params = {}) {
  return defaultApiInstance.get(`v1/counteragent`, { params });
}

export function getCounteragent(id) {
  return defaultApiInstance.get(`v1/counteragent/${id}`);
}

export function createCounteragent(data) {
  return defaultApiInstance.post(`v1/counteragent/create`, JSON.stringify(data));
}

export function updateCounteragent(id, data) {
  return defaultApiInstance.put(`v1/counteragent/${id}/update`, JSON.stringify(data));
}

export function deleteCounteragent(id) {
  return defaultApiInstance.delete(`v1/counteragent/${id}/delete`);
}
